// The name a document shows everywhere (plans/DOCUMENT_TITLES_PLAN.md): its own
// title when it has one (a person's, the title stage's, or a reading), else the
// title cut out of a child's file name, else the file name. The file name never
// disappears — it is the second line and the tooltip.
import { cutChildParts, isCutChild } from '../components/segments/cutChild';

export function docTitle(doc, parentFilename = null) {
  if (!doc) return '';
  const own = String(doc.title || '').trim();
  if (own) return own;
  if (isCutChild(doc)) return cutChildParts(doc.filename, parentFilename).title;
  return doc.filename || 'Untitled';
}

export const hasOwnTitle = (doc) => !!(doc && String(doc.title || '').trim());

export const TITLE_SOURCE_LABEL = {
  person: 'your title',
  generated: 'named by Chargestack',
  reading: 'a first reading',
};
